// extracted by mini-css-extract-plugin
export default {"formContainer":"SignSuccessInfo_formContainer__QXakh","warning":"SignSuccessInfo_warning__L5E3x","underline":"SignSuccessInfo_underline__pdMEH","btn":"SignSuccessInfo_btn__b37J6"};